import last from 'lodash/last'

function getPathFromId(id){
    return id.split('_').slice(1).join('.');
}

function getCurrentKeyFromId(id) {
    return last(id.split('_'))
}

export { getCurrentKeyFromId }

export default getPathFromId;